import {put, fork, select, take} from 'redux-saga/effects';
import {persistenceStates} from '@ace-de/eua-entity-types';
import * as dashboardActionTypes from '../dashboardActionTypes';
import fetchRequest from '../../application/sagas/fetchRequest';
import dashboardScreenTabs from '../dashboardScreenTabs';
import leaAccessControl from '../../leaAccessControl';
import {leaFeatures, leaFeatureActions} from '../../application/leaFeatures';

export const loadReporterInvoicesAmount = function* loadReporterInvoicesAmount({payload}) {
    const isKPIInfoAvailable = leaAccessControl.grantFeatureAccess(leaFeatures.KPI_INFO, leaFeatureActions.READ);
    if (!isKPIInfoAvailable) return;

    const {location} = payload;
    const {serviceManager} = yield select(state => state.application);
    const leaAssignmentFlowService = serviceManager.loadService('leaAssignmentFlowService');

    if (location.query.activeTab === dashboardScreenTabs.DASHBOARD) return;

    yield put({
        type: dashboardActionTypes.SET_REPORTER_INVOICES_PERSISTENCE_STATE,
        payload: {newPersistenceState: persistenceStates.PENDING},
    });

    yield fork(
        fetchRequest,
        dashboardActionTypes.FETCH_REPORTER_INVOICES_AMOUNT_REQUEST,
        leaAssignmentFlowService.getReporterInvoicesCount,
    );
    const responseAction = yield take([
        dashboardActionTypes.FETCH_REPORTER_INVOICES_AMOUNT_REQUEST_SUCCEEDED,
        dashboardActionTypes.FETCH_REPORTER_INVOICES_AMOUNT_REQUEST_FAILED,
    ]);

    yield put({
        type: dashboardActionTypes.SET_REPORTER_INVOICES_PERSISTENCE_STATE,
        payload: {newPersistenceState: persistenceStates.READY},
    });

    if (!responseAction.error) {
        const {response} = responseAction.payload;
        const {reporterInvoiceAmounts} = response;

        yield put({
            type: dashboardActionTypes.STORE_REPORTER_INVOICES_AMOUNT,
            payload: {reporterInvoiceAmounts},
        });
    }
};

export default loadReporterInvoicesAmount;
